export { LazySuspense } from './component';
export { LazySuspenseContext } from './context';
export type {
  Fallback,
  LazySuspenseContextType,
  LazySuspenseProps,
} from './types';
